import React from "react";
import { ReactElement } from "react";
import { Badge, Banner, FooterHelp, InlineStack, Icon, Link, Text } from '@shopify/polaris';
import Imageuploadtutorial from "../components/Image/Imageuploadtutorial";
import { ChevronRightMinor, CircleInformationMajor, InfoMinor } from "@shopify/polaris-icons";
import CustomDropZone from "../components/Image/CustomDropZone";
import { amazon_regions } from "../../Onboarding/components/onboardinghelper";
import { formatPrice } from "../components/Price/pricehelper";
import { GetAndSetDefaultValuesI } from "../components/Customcomponents/Interfaces/interfaces";
import { formatQuantityExtended } from "../components/quantity/quantityHelper";
import { scope } from "./customHelperFunctions";
import { TextFieldHover } from "../components/Customcomponents/Components/TextfieldHover";
import { getStatusFormatted } from "./statusHelper";
import { getAmazonStatus } from "../../Settings/Template/Components/FilterProducts/FilterProductsHelper";
import _ from "lodash";
import { getFinalPrice, removeCurrencySign, validatePriceEntries } from "../components/BusinessPrice/BusinessPriceN";
let { hasLength, dataTypeLength } = scope;
import NoImage from '../../../../Asests/Images/no-image-new.png';

export const attributeErrorMessages = {
  barcode: [
    "Product does not have a valid ASIN for offer creation. Please initiate lookup to fetch offer status.",
    "Barcode is a required field, please fill barcode and upload again.",
    "Barcode must be of type EAN, GTIN, EAN-8, or UPC for product validation.",
    "Barcode is not valid, please provide a valid barcode and upload again."
  ],
  condition_type: [
    "You are not authorized to sell this product under the requested condition type.",
    '"condition_type" is required but not supplied.'
  ],
  category_settings: [
    "Amazon Category is not selected. Click on Product to edit & select an Amazon Category to upload this Product."
  ],
  sku: [
    "Sku is a required field, please fill sku and upload again.",
    "SKU lengths are exceeding the 40 character limit."
  ],
  price: [
    "Price is a required field, please fill price and upload again.",
    "Minimum price should not be greater than Standard price.",
    "Sale price should not be greater than Standard price.",
    "Price should be greater than 0.01, please update it from the shopify listing page."
  ],
  inventory: [
    "Quantity is a required field, please fill quantity and upload again."
  ],
  default: [
    "Offers cannot be created for parent products."
  ],
  description: [
    "Product Descriptions are exceeding the 2000 characters limit. HTML tags and spaces do count as characters."
  ],
  title: [
    "Product name is exceeding the 200 characters limit. Spaces and special characters do count as characters."
  ],
  image_selection: [
    "The selected action cannot be performed on this product because product does not have contains image."
  ],
  fulfillment_type: [
    "Seller is not Authorised to List on FBA"
  ]
};

export const errorCodeToMessage: Record<string, string> = {
  AmazonError101: "Amazon Category is not selected. Click on Product to edit & select an Amazon Category to upload this Product.",
  AmazonError102: "Sku is a required field, please fill sku and upload again.",
  AmazonError103: "Product Descriptions are exceeding the 2000 characters limit. HTML tags and spaces do count as characters.",
  AmazonError104: "SKU lengths are exceeding the 40 character limit.",
  AmazonError105: "Price is a required field, please fill price and upload again.",
  AmazonError106: "Price should be greater than 0.01, please update it from the shopify listing page.",
  AmazonError107: "Product Syncing is Disabled. Please Enable it from the Settings and Try Again.",
  AmazonError108: "Quantity is a required field, please fill quantity and upload again.",
  AmazonError109: "Barcode is a required field, please fill barcode and upload again.",
  AmazonError110: "Barcode must be of type EAN, GTIN, EAN-8, or UPC for product validation.",
  AmazonError111: '"condition_type" is required but not supplied.',
  AmazonError301: "Product does not have a valid ASIN for offer creation. Please initiate lookup to fetch offer status.",
  AmazonError305: "Product name is exceeding the 200 characters limit. Spaces and special characters do count as characters.",
  AmazonError309: "Seller is not Authorised to List on FBA",
  AmazonError124: "The selected action cannot be performed on this product because it is not fulfilled by merchant(FBM).",
  AmazonError161: "The selected action cannot be performed on this product because product does not have contains image.",
  // Add other codes as needed...
};

export const errorCodeToAttribute: Record<string, string> = {
  AmazonError101: "category_settings",
  AmazonError102: "sku",
  AmazonError103: "description",
  AmazonError104: "sku",
  AmazonError105: "price",
  AmazonError106: "price",
  AmazonError107: "default",
  AmazonError108: "inventory",
  AmazonError109: "barcode",
  AmazonError110: "barcode",
  AmazonError111: "condition_type",
  AmazonError301: "barcode",
  AmazonError305: "title",
  AmazonError309: "fulfillment_type",
  AmazonError124: "default",
  AmazonError161: "image_selection",
  // Add other codes as needed...
};

export function extractDataFromRequest(data: any = []) {
  let modifiedRows: any = [];
  Object.keys(data).forEach((row: any) => {
    let { variant_image, variant_title, sku, main_image, barcode, source_product_id } = data[row];
    modifiedRows.push({
      variant_image: variant_image === '' ? main_image : variant_image,
      variant_title,
      sku,
      barcode,
      source_product_id
    })
  });
  return modifiedRows;
}

export function productType(product: any) {
  if (product?.['visibility'])
    return product?.['visibility'] === "Catalog and Search";
  else return false
}
export function getProductStatus(marketplace: any, props: any) {
  let status: any = '';
  let found: boolean = false;
  marketplace?.map((element: any) => {
    if (element?.['shop_id'] === props.redux.current.target._id && element?.['target_marketplace'] === 'amazon' && !found) {
      status = element?.['status'] ?? 'Not Listed';
      found = true;
    }
  });
  return status === '' ? 'Not Listed' : status;
}

export function getDefaultValue(field: any, state: any) {
  return state?.selection_type?.[field] === 'default' ? state?.['shopify_data']?.[field] : state?.['data']?.[field];
}

export function getCustomValue(field: any, state: any, value: string) {
  return value === 'default' ? state?.['shopify_data']?.[field] : state?.['data']?.[field];

}

export function showDisabledBanner(field: string, productStatus: string, t: any) {
  return (
    <Banner><Text as='p' tone="subdued">
      {t("Since your product is")} {<Badge tone={getAmazonStatus(productStatus ?? '')}>{t(productStatus)}</Badge>} {t("on Amazon, you cannot change")} <Text as='span' fontWeight="semibold">{t(field)}</Text>
    </Text></Banner>
  );
}

export function isPageLoading(componentState: any = []) {
  return Object?.values(componentState?.['loaders'] ?? {})?.includes(true);
}

export function extractCurrencySettings(settings: any = []) {
  let currency_settings: any = settings.filter((elem: any) => elem?.['key'] === 'currency');
  if (hasLength(settings)) {
    if (currency_settings !== null && currency_settings !== undefined) {
      return currency_settings?.[0]?.['value']?.['target_value'] || 1;
    }
  }
  else return 1;
}

export function renderFormattedQuantity(quantity: any = [], t: any) {
  let tempValue: any = [];
  let tooltipValue: any = '';
  if (hasLength(quantity)) {
    [quantity].map((elem: any, idx) => {
      tempValue.push(
        <React.Fragment key={idx}>
          <Text as='p' fontWeight='semibold'>{t("Inventory Breakup:")}</Text>
          <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>{t("Shopify Inventory:")}</Text>
            <Text as='p'>{elem?.['shopify_quantity']}</Text>
          </InlineStack>
          <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>{elem?.['label']}:</Text>
            <Text as='p'>{elem?.['value']}</Text>
          </InlineStack>
        </React.Fragment>
      )
    })
    tooltipValue = quantity?.['value'];
  }
  else {
    tooltipValue = t('N/A');
  }
  return <TextFieldHover content={tempValue} value={tooltipValue} />
}

function roundOffText(round_off_option: any) {
  switch (round_off_option) {
    case 'higherWholeNumber': return 'Nearest Higher Whole Number';
    case 'higherEndWith9': return 'Nearest Higher Ending with 9';
    case 'higherEndWith0.99': return 'Nearest Higher Ending with 0.99';
    case 'higherEndWith0.49': return 'Nearest Higher Ending with 0.49';
    case 'higherEndWith10': return 'Nearest Higher Ending with 10';
    case 'lowerWholeNumber': return 'Nearest Lower Whole Number';
    case 'lowerEndWith9': return 'Nearest Lower Ending with 9';
    case 'lowerEndWith0.99': return 'Nearest Lower Ending with 0.99';
    case 'lowerEndWith0.49': return 'Nearest Lower Ending with 0.49';
    case 'lowerEndWith10': return 'Nearest Lower Ending with 10';
    default: return 'No round off';
  }
}

export function renderFormattedPrice(formatted_price: any = [], props: any = [], from: string = "there") {
  let tempValue: any = [];
  let tooltipValue: any = '';
  let price_roundoff_value = formatted_price?.price_roundoff_value?.length > 0 ? formatted_price?.price_roundoff_value[0] != '0' : false;
  let current_shop_details = getMarketplaceId(props?.redux?.current?.target?.['warehouses']);
  let source_currency = props?.redux?.current?.source?.currency;
  let target_currency = props?.redux?.current?.target?.currency;
  if (formatted_price) {
    let temp: any = [formatted_price];
    temp.map((elem: any, idx: number) => {
      tempValue.push(
        <React.Fragment key={idx}>
          <Text as='p' fontWeight='semibold'>Price Breakup:</Text>
          <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>Shopify Price:</Text>
            <Text as='p'>{source_currency}{' '}{elem?.['shopify_price']}</Text>
          </InlineStack>
          {elem?.formatted_price && <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>{elem?.label}:</Text>
            <Text as='p'>{elem?.label.includes('Percentage') ? null : current_shop_details?.['currency_symbol']}{elem?.formatted_price}</Text>
          </InlineStack>}
          {price_roundoff_value && <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>Price Round Off : </Text>
            <Text as='p'>{roundOffText(typeof formatted_price?.price_roundoff_value === 'string' ? formatted_price?.price_roundoff_value : formatted_price?.price_roundoff_value[0])}</Text>
          </InlineStack>}
          {elem?.['conversion_value_found'] && <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' tone='subdued'>{elem?.currency_settings?.label}:</Text>
            <div style={{ width: '180px', wordBreak: 'break-all' }}>
              <Text as='p'>{current_shop_details?.['currency_symbol']}{elem?.currency_settings?.conversion_value}</Text>
            </div>
          </InlineStack>}
          {elem?.['conversion_value_found'] ? <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' fontWeight='semibold'>Price:</Text>
            <Text as='p'>{current_shop_details?.['currency_symbol']}{elem?.currency_settings?.calculated_value > 0 ? elem?.currency_settings?.calculated_value : 0}</Text>
          </InlineStack> : <InlineStack blockAlign='center' align='space-between'>
            <Text as='p' fontWeight='semibold'>Price:</Text>
            <Text as='p'>{current_shop_details?.['currency_symbol']}{elem?.calculated_value > 0 ? elem?.calculated_value : 0}</Text>
          </InlineStack>}
        </React.Fragment>
      )
    })
    tooltipValue = formatted_price?.['conversion_value_found'] ?
      (current_shop_details?.['currency_symbol'] || '') + (formatted_price?.['currency_settings']?.['calculated_value'] > 0 ? formatted_price?.['currency_settings']?.['calculated_value'] : 0) :
      (current_shop_details?.['currency_symbol'] || '') + (formatted_price?.calculated_value > 0 ? formatted_price?.calculated_value : 0);
  }
  return <TextFieldHover content={tempValue} value={tooltipValue} icon={{ color: 'warning', icon: InfoMinor }} />
}

export function compareObjects(obj1: any, obj2: any) {
  if (obj1 === obj2) {
    return true; // Both objects are identical
  }

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false; // One of them is not an object or is null
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false; // Different number of keys
  }

  for (let key of keys1) {
    if (!keys2.includes(key)) {
      return false; // obj2 does not contain a key from obj1
    }

    if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
      if (!compareArrays(obj1[key], obj2[key])) {
        return false; // Arrays are not equal
      }
    } else if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      if (!compareObjects(obj1[key], obj2[key])) {
        return false; // Nested objects are not equal
      }
    } else if (obj1[key] !== obj2[key]) {
      return false; // Primitive values are not equal
    }
  }

  return true; // All key-value pairs are equal
}

export function compareArrays(arr1: any, arr2: any) {
  if (arr1.length !== arr2.length) {
    return false; // Different number of elements
  }

  for (let i = 0; i < arr1.length; i++) {
    if (typeof arr1[i] === 'object' && typeof arr2[i] === 'object') {
      if (!compareObjects(arr1[i], arr2[i])) {
        return false; // Nested objects are not equal
      }
    } else if (arr1[i] !== arr2[i]) {
      return false; // Primitive values are not equal
    }
  }

  return true; // All elements are equal
}

export function getSanitizedPrice(priceObj: any) {
  const allowedKeys = ["attribute", "value", "price_roundoff_value"];
  const filteredObject: any = {};

  for (const key in priceObj) {
    if (allowedKeys.includes(key)) {
      filteredObject[key] = priceObj[key];
    }
  }

  return filteredObject;
}

export function getSanitizedQuantity(quantityObj: any) {
  const allowedKeys = ["continue_selling", "effective_inventory", "attribute", "value"];
  const filteredObject: any = {};

  for (const key in quantityObj) {
    if (allowedKeys.includes(key)) {
      filteredObject[key] = quantityObj[key];
    }
  }
  return filteredObject;
}

export function structuredProductData(product: any = [], componentState: any = []) {

  let { data, selection_type, listing_type } = product;
  let tempArr: any = [];

  if (Object.keys(product).length > 0) {
    Object.keys(data).map((field: any) => {
      if (field != 'barcode_exemption') {
        if (field === 'main_image' || field === 'additional_images') {
          // if (selection_type['image_selection'] === 'default') {
          //   tempArr['unset'] = {
          //     ...tempArr['unset'],
          //     [field]: 1
          //   }
          // }
          // else {
          if (field === 'additional_images') {
            data[field] = data[field].filter((img: string) => img !== data?.main_image)
          }
          tempArr = {
            ...tempArr,
            [field]: data[field]
          }
          // }
        }
        else {
          if (selection_type[field] === 'default' && field !== 'barcode_type') {//testAshish needed
            tempArr['unset'] = {
              ...tempArr['unset'],
              [field]: 1,
              ...(field === "price" && { 'price_rules': 1 })
            };
          }
          else {
            tempArr = {
              ...tempArr,
              // [field]: field === 'quantity' ? +data[field] : data[field] //only send quantity as integer, not price
              [field]: data[field]
            }
          }
        }
      }
    })
  }

  tempArr = {
    ...tempArr,
    category_settings: {
      barcode_exemption: listing_type == 'offer_listing' ? false : data?.['barcode_exemption'] ?? false,
    }
  }

  if (componentState['product_type']['variantEdit'] || !componentState.initialProductData['hasVariants']) {
    if (product?.hasOwnProperty('localsellingStoreData') && product?.localsellingStoreData?.length > 0) {
      let removeStatusKeyFromLocalSelling = JSON.parse(JSON.stringify(product?.localsellingStoreData));
      removeStatusKeyFromLocalSelling?.map((removeKey: any, index: any) => {
        delete removeKey.status
      })
      tempArr = {
        ...tempArr,
        localsellingStoreData: [...removeStatusKeyFromLocalSelling]
      }
    }
  }
  return tempArr;
}

// export const defaultImage = 'https://i.imgur.com/oUVyG2C.png';
export const defaultImage = NoImage;

export function getSelectedImagesCount(array: any = []) {
  return array.filter((ele: string, ind: number) => ele != defaultImage);
}

export function getModalStructure(type: string, t: any, value?: any, onDataChange = () => { }, exceededFiles?: any): ReactElement | any {
  switch (type) {
    case 'imageupload':
      return <CustomDropZone exceededFiles={exceededFiles} />
    case 'knowmoreonuploadingimages':
      return <Imageuploadtutorial />
    default:
      return <>{t("Something went wrong!")}</>
  }
}

export const AVAILABLE_FOR_OFFER = "Not Listed: Offer"

const validationKeys = ['sku', 'title', 'description', 'source_product_id', 'container_id', "inventory_fulfillment_latency", 'barcode', 'quantity', 'price', 'localsellingStoreData'];

export function prepareDisplayPath(displayPath: any = []) {
  if (displayPath.length > 0) {
    // return displayPath?.toString()?.split(',')?.join(',')?.replace(/,/g, ' > ') ?? 'Path Array not found!'
    let arr: any = displayPath.map((category: string, index: number) => {
      return (
        <InlineStack gap="100">
          <Text as='p'>{category}</Text>
          {index != displayPath.length - 1 && <div><Icon source={ChevronRightMinor} /></div>}
        </InlineStack>
      );
    });

    return arr;
  }
}

function getErrorByPriority(type: any) {
  const errors: any = {
    category_settings: 1,
    title: 2,
    description: 3,
    sku: 4,
    price: 5,
    barcode: 6,
    barcode_type: 14,
    main_image: 7,
    image_selection: 8,
    inventory_fulfillment_latency: 9,
    variation_theme_attribute_name: 10,
    localsellingStoreData: 11,
    variation_theme_attributes: 12,
    variation_theme_fields: 13
  }
  return errors?.[type];
}

export function getErrorBySectionName(errors: any = [], t: any) {
  let tempErrors: any = {};
  let priorityHolder: number[] = [];
  if (errors?.length > 1) {
    tempErrors = refineErrors(errors.filter((elem: any) => elem?.['parent'])?.[0] ?? {}, t);
  }
  else {
    tempErrors = refineErrors(errors?.[0] ?? {}, t);
  }
  if (tempErrors && hasLength(tempErrors)) {
    Object.keys(tempErrors).map(ele => priorityHolder.push(tempErrors[ele]['priority']));
    priorityHolder.sort(function (a, b) { return a - b });
  }
  return Object.keys(tempErrors).map(elem => {
    if (tempErrors[elem]['priority'] === priorityHolder?.[0])
      return tempErrors[elem];
  }).filter(element => element)?.[0] ?? {}
}
function refineErrors(param: object | any = {}, t: any) {
  let tempObj: any = {};
  const validateKeys = ['title', 'description', 'sku', 'price', 'barcode', 'main_image', 'image_selection', 'inventory_fulfillment_latency', 'inventory', 'localsellingStoreData'];
  Object.keys(param).forEach((ele: any) => {
    if (param[ele] && validateKeys.includes(ele)) {
      tempObj[ele] = {
        message: `${refineErrorName(ele)} ${t("is missing or wrong, kindly check it before proceeding.")}`,
        priority: getErrorByPriority(ele),
        scroll_to: ele
      }
    }
  });
  return tempObj
}

function refineErrorName(error_name: string = '') {
  if (error_name === 'inventory_fulfillment_latency') {
    error_name = 'Handling Time'
  }
  return error_name[0].toUpperCase() + error_name.substring(1, error_name?.length)?.replace(/_/g, ' ');
}

export const businessPriceValidator = (state: any, defaultBusinessErr: any, showBusinessPrice: boolean, props: any, t: any, containerState: any) => {
  const errData: any = JSON.parse(JSON.stringify(defaultBusinessErr));
  const businessPriceEnabled = state?.data?.business_price_enabled ?? false;
  const businessPrice: any = state?.data?.business_price;
  let hasError: boolean = false;
  const selection_type = state?.selection_type;
  if (selection_type?.business_price == "custom") {
    if (businessPriceEnabled) {
      if (businessPrice['selection_type'] == "") {
        hasError = true;
        errData['selectionType'] = true;
      }

      if (businessPriceEnabled) {
        if (businessPrice['attribute'] == "") {
          hasError = true;
          errData['attribute'] = true;
        }

        if (businessPrice['value'] == "") {
          hasError = true;
          errData['value'] = true;
        }

        if (businessPrice?.attribute == "percentage_decrease") {
          if (businessPrice['value'] == "" || +businessPrice['value'] >= 100) {
            errData['value'] = true;
            hasError = true;
          }
        } else if (businessPrice?.attribute == "value_decrease") {
          const { data, selection_type: selectionType, raw_data } = state;
          const { rawPriceSettings } = raw_data;
          const { currency_settings, from, shopify_price, standard_price } = rawPriceSettings;
          const { price } = data;
          const effectivePriceSettings = selectionType?.price == "default" ? standard_price : price;


          let myPrice: any = "";
          if (effectivePriceSettings?.attribute === "custom") {
            myPrice = effectivePriceSettings?.value
          }
          else if (effectivePriceSettings?.attribute == "default") {
            myPrice = shopify_price;
          }
          else {
            let formattedPrice: any = formatPrice({
              props: props,
              shopify_price: shopify_price ?? 0,
              settings_enabled: effectivePriceSettings && Object?.keys(effectivePriceSettings)?.length > 0,
              standard_price: effectivePriceSettings ?? [],
              currency_settings: currency_settings
            });
            myPrice = +(formattedPrice?.currency_settings?.calculated_value ?? 0);
          }

          errData['value'] = containerState?.['product_type']?.['variantEdit'] ||
            !containerState?.initialProductData?.['hasVariants']
            ? businessPrice['value'] === "" || +businessPrice['value'] >= myPrice
            : businessPrice['value'] === "";
          hasError = containerState?.['product_type']?.['variantEdit'] ||
            !containerState?.initialProductData?.['hasVariants']
            ? businessPrice['value'] === "" || +businessPrice['value'] >= myPrice
            : businessPrice['value'] === "";
        }

        if (showBusinessPrice) {
          if (businessPrice['quantity_type'] == "") {
            hasError = true;
            errData['quantity_type'] = true;
          }

          if (businessPrice['quantity_type'] && businessPrice['quantity_type'] != "") {
            // Call validatePriceEntries function
            const validationErrors = validatePriceEntries(
              businessPrice,
              state,
              getFinalPrice,
              "product_edit",
              businessPrice[businessPrice?.quantity_type],
              errData[businessPrice.quantity_type],
              "save", t, !(containerState?.['product_type']?.['variantEdit'] ||
                !containerState?.initialProductData?.['hasVariants'])
            );

            errData[businessPrice.quantity_type] = JSON.parse(JSON.stringify(validationErrors));
            hasError = validationErrors.some((error: any) => error.hasError);
          }
        }
      }
    }
  }

  return { businessErrData: errData, businessErr: hasError };
}

export const priceValidator = (state: any, defaultPriceErr: any, props: any) => {
  const errData: any = JSON.parse(JSON.stringify(defaultPriceErr));
  let hasError: boolean = false;
  const { selection_type, data } = state;
  const { price } = data;
  const { attribute, value } = price;
  if (selection_type?.price == "custom") {
    if (attribute == "") {
      hasError = true;
      errData['attribute'] = true;
    }

    if (attribute !== "" && attribute != "default" && value == "") {
      hasError = true;
      errData['value'] = true;
    }
  }
  return { priceErrData: errData, priceErr: hasError };
}

export const quantityValidator = (state: any, defaultQuantityErr: any, props: any) => {
  const errData: any = JSON.parse(JSON.stringify(defaultQuantityErr));
  let hasError: boolean = false;
  const { selection_type, data } = state;
  const { quantity } = data;
  const { continue_selling, effective_inventory, attribute, value } = quantity;
  if (selection_type?.quantity == "custom") {
    if (effective_inventory.enabled) {
      if (effective_inventory.type == "none") {
        if (!hasError) hasError = true;
        errData.effective_inventory = true;
      }
      else {
        if (quantity.effective_inventory.value == '' || quantity.effective_inventory.value == 0) {
          if (!hasError) hasError = true;
          if (quantity.effective_inventory.type == 'fixed') {
            errData.fixed_inventory = true;
          }
          else if (quantity.effective_inventory.type == 'reserved') {
            errData.reserved_inventory = true;
          }
          else if (quantity.effective_inventory.type == 'threshold') {
            errData.threshold_inventory = true;
          }
        }
      }
    }

    if (attribute == "") {
      if (!hasError) hasError = true;
      errData.attribute = true;
    }
    else if (attribute == "custom" && value == "") {
      if (!hasError) hasError = true;
      errData.value = true;
    }
  }
  return { quantityErrData: errData, quantityErr: hasError };
}

export function validator(data: any = [], state: any = [], componentState: any = [], new_product: boolean = false) {

  //status == Uploaded,Active,Inactive,Incomplete
  let validatedKeys: any = [];
  let hasError: boolean = false;
  if (Object.keys(data).length > 0) {
    data.map((ele: any, index: number) => {
      validatedKeys.push(applyValidation(ele, index, hasError, state, componentState, new_product))
    })
  }

  Object.keys(validatedKeys).forEach(ele => {
    Object.keys(validatedKeys[ele]).map(elem => {
      switch (elem) {
        case 'barcode':
          if (!state?.data?.barcode_exemption) {
            if (!hasError) hasError = validatedKeys[ele][elem];
          }
          break;
        case 'localsellingStoreData':
          if (!hasError) hasError = Object.values(validatedKeys[ele][elem]).includes(true)
          break
        default:
          if (elem != 'parent')
            if (!hasError) hasError = validatedKeys[ele][elem];
          break;
      }
    })
  });

  let parent_errors = validatedKeys?.find((a: any) => a.parent);
  let variants_errors = validatedKeys.filter((a: any) => !a.parent)
  parent_errors && !new_product && (parent_errors.variation_theme_fields = variants_errors?.some((a: any) => Object.values(a?.variation_theme_fields ?? {})?.includes(true)))


  return { validatedKeys, hasError }
}

export function applyValidation(data: any, index: number, hasError: boolean, state: any = [], componentState: any = [], new_product: boolean = false) {
  let errors: any = {};
  let tempErrors: any = [];
  Object.keys(data).map((ele: any) => {
    if (validationKeys.includes(ele) && data?.[ele] != undefined) {
      if (ele === 'inventory_fulfillment_latency') {
        errors = {
          ...errors,
          [ele]: data[ele] === '' || data[ele] < 0 || `${data?.[ele]}`?.trim()?.length === 0 || data[ele] > 30
        }
      }
      else if (ele === 'quantity') { //only quantity, price ka validation change ho gya hai
        if ((componentState['product_type']['variantEdit'] || !componentState.initialProductData['hasVariants'])) {
          errors = {
            ...errors,
            [ele]: data[ele] === ''
            // [ele]: ele === 'quantity' ? data[ele] === '' : data[ele] === '' || data[ele] === 0
          }
        }
      } else if (ele === 'localsellingStoreData' && state?.data?.localSelling) {
        if ((componentState['product_type']['variantEdit'] || !componentState.initialProductData['hasVariants'])) {
          errors = {
            ...errors,
            [ele]: validateLocalSellingStoreData(data[ele])
          }
        }
      } else if (ele === "description") {
        errors = {
          ...errors,
          [ele]: data[ele] === '' || data[ele].trim().length === 0 || data[ele] == '<p></p>' || data[ele] == '<p><br></p>' || data[ele] == '<p></p>\n' || (!data?.unset?.hasOwnProperty('description') && data[ele]?.length > 2000)
        }
      }
      else if (ele === "title") {
        errors = {
          ...errors,
          [ele]: data[ele] === '' || data[ele].trim().length === 0 || (!data?.unset?.hasOwnProperty('title') && data[ele]?.length > 200)
        }
      }
      else if (ele === "sku") {
        errors = {
          ...errors,
          [ele]: data[ele] === '' || data[ele].trim().length === 0 || (!data?.unset?.hasOwnProperty('sku') && data[ele]?.length > 40)
        }
      }
      else {
        errors = {
          ...errors,
          [ele]: typeof data[ele] === 'object' ? Object.keys(data[ele]).length === 0 : data[ele] === '' || data[ele]?.trim()?.length === 0,
          parent: data['source_product_id'] === data['container_id']
        }
      }
    }
  });
  if (state?.['selected_images']) {
    let tempCount: number = 0;
    state?.['selected_images'].forEach((image: any) => {
      if (image === defaultImage) tempCount += 1;
    });
    errors = {
      ...errors,
      image_selection: tempCount === 9
      // && state?.selection_type?.['image_selection'] === 'custom'
    }
  }
  if (state?.hasOwnProperty('isSellerEnabledForLocalSelling') && state?.isSellerEnabledForLocalSelling && !state?.data?.onlineSelling && !state?.data?.localSelling) {
    errors = {
      ...errors,
      onlineSelling: !state?.data?.onlineSelling && !state?.data?.localSelling,
      localSelling: !state?.data?.onlineSelling && !state?.data?.localSelling
    }
  }
  return { ...errors }
}

function validateLocalSellingStoreData(storeData: any) {
  let error: any = {};
  storeData?.length > 0 && storeData?.map((store: any) => {
    if (store?.store_enabled) {
      // error[store?.store_id] = store?.store_value === '' || store?.store_value.trim().length === 0 ? true : false;
      error[store?.store_id] = (store?.shopify_location && Object?.keys(store?.shopify_location).length == 0) ?? false;
    } else {
      error[store?.store_id] = false;
    }
  })
  return error;
}

export const CustomLabel = (props: any) => {
  return <Text as='span'>
    {props?.title}{props?.isRequired && <span style={{ color: 'red' }}> *</span>}
  </Text>
}

export function formatAmazonRecommendation(amazon_attributes: any = []) {
  let temp = { label: 'Set new', value: 'custom' }
  let modifiedAmazonAttributes: any = [];
  Object.keys(amazon_attributes)?.map((ele: any) => {
    modifiedAmazonAttributes.push({
      label: ele, value: amazon_attributes[ele]
    })
  });
  return modifiedAmazonAttributes ?? {};
}

export function switchAmazonOptions(amazon_options: any[], selected_options: any = []) {
  if (hasLength(amazon_options)) {
    amazon_options?.forEach((opt: any) => {
      opt?.['options']?.forEach((elem: any) => {
        elem['isDisabled'] = selected_options.includes(elem?.['label']) || selected_options.includes(elem?.['value']);
      })
    })
  }
}

export function useParentErrors(props: any, isParent: boolean = true): any {
  let parentErrors: any = {}
  if (props?.['errors']) {
    if (props?.['errors']?.length > 1) {
      parentErrors = props?.['errors'].filter((ele: any) => ele['parent']);
    }
    else parentErrors = props?.['errors'];
  }
  return { ...parentErrors['0'] }
}

export function showErrorSymbol(state: any = [], key: string = '', title: string = '', isRequired: boolean = false) {
  //if there are any errors, show info icon.
  let errors = useParentErrors(state);
  return (
    <InlineStack blockAlign='center' gap="100">
      {errors?.[key] && <div><Icon
        source={InfoMinor}
        tone="critical" /></div>}
      <CustomLabel title={title} isRequired={isRequired} />
    </InlineStack>
  );
}

export function getAndSetDefaultValues(params: GetAndSetDefaultValuesI) {
  let default_values: any = {};
  let { element, fields, props, default_profile_settings } = params;
  fields?.length > 0 &&
    fields.map(field => {
      if (element?.[field]?.['value']) {
        default_values[field] = element?.[field];
      }
      else if (element?.profile_info && Object.keys(element?.profile_info)?.length > 0) {
        default_values[field?.['value']] = extractSettingsFromTemplate(element?.profile_info, field);
      }
      else {
        default_profile_settings.forEach((elem: any) => {
          if (Object.keys(elem?.['value']).includes(field?.['value'])) {
            default_values[field?.['value']] = elem?.['value'][field['value']]
          }
        });
      }
    });
  return { ...default_values }
}

function extractSettingsFromTemplate(profile_info: any = {}, setting_type: any = '') {
  let extracted_setting_type: any = undefined;
  if (Object.keys(profile_info)?.length > 0 && profile_info?.data) {
    profile_info.data.filter((setting: any) => {
      if (setting?.['data_type'] === setting_type?.['key']) {
        extracted_setting_type = setting?.['data']?.[setting_type?.['value']] ?? undefined;
      }
    });
  }
  return extracted_setting_type
}

export function unsetCategoryDetails() {
  return {
    "category_settings.primary_category": 1,
    "category_settings.sub_category": 1,
    "category_settings.browser_node_id": 1,
    "category_settings.displayPath": 1,
    "category_settings.parentNodes": 1,
    "category_settings.full_path": 1,
    "category_settings.attributes": 1,
    "category_settings.from": 1,
    "category_settings.mutated": 1,
  }
}

export function getMarketplaceId(warehouses: any) {
  let tempWarehouse: any = ''
  amazon_regions.filter(region => {
    if (region?.['marketplace_id'] === warehouses?.[0]?.['marketplace_id']) {
      tempWarehouse = region
    }
  });
  return tempWarehouse;
}

export function renderFooter(props: any, t: any) {
  return (
    <FooterHelp>
      <InlineStack align="center" gap="100">
        <div>
          <Icon
            source={CircleInformationMajor}
            tone="info"
          />
        </div>{t("Learn more about")}<Link target='_blank' url="https://support.cedcommerce.com/portal/en/kb/articles/overview-26-3-2024">
          {t("CedCommerce Amazon Channel")},
        </Link><Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf'>
          {t("Terms & Conditions")}
        </Link>{t("and")}<Link target='_blank' url='https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf'>
          {t("Data Privacy Rights.")}
        </Link>{t("Need Help?")}<Link target='_blank'
          url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}>
          {t("Get Support")}
        </Link>or<Link target='_blank' url="https://calendly.com/cedcommerce-awe-sales/sales" >
          {t("Book a Call")}
        </Link>
      </InlineStack>
    </FooterHelp>
  );
}

export function getAmazonLink(props: any) {
  let tempMarketplaceId: string = props.redux.current.target.warehouses?.[0]?.['marketplace_id'];
  let marketplace_id: any = '';
  amazon_regions.map(elem => {
    if (elem?.['marketplace_id'] === tempMarketplaceId)
      marketplace_id = elem?.['url'];
  });
  return marketplace_id?.toLowerCase();
}

export function generateParamsForMissingDetails(props: any = [], edited: any = []) {
  return {
    missing_params: {
      browser_node_id: edited?.category_settings?.browser_node_id,
      primary_category: edited?.category_settings?.primary_category,
      sub_category: edited?.category_settings?.sub_category,
    },
    user_id: props.di.user_id,
    target: {
      marketplace: 'amazon',
      shopId: props.redux.current.target?.['_id']
    },
    source: {
      marketplace: 'shopify',
      shopId: props.redux.current.source?.['_id']
    },
    props
  }
}

export const setParentStatus = (rows: any, sourceShopID: any, targetShopID: any) => {
  let parentRow = rows.find((row: any) => row?.visibility === 'Catalog and Search')
  let parentStatus = getStatusFormatted(parentRow, { sourceShopID, targetShopID }).label
  if (parentRow?.type === 'simple') return parentStatus;

  let variantRows = rows.filter((row: any) => row?.visibility === "Not Visible Individually")
  let variantStatuses = variantRows.map((row: any) => {
    let status = getStatusFormatted(row, { sourceShopID, targetShopID }).label
    if (status == 'Active' || status == "Inactive" || status == "Incomplete") return 'Listed'
    else return 'Not Listed'
  })
  if (variantStatuses.filter((status: string) => status !== 'Listed').length === 0) return 'Listed';
  else if (variantStatuses.filter((status: string) => status !== 'Not Listed').length === 0) return 'Not Listed';
  return 'Partial Listed'
}

export const setVariantStatus = (rows: any, sourceShopID: any, targetShopID: any) => {
  let variantRow = rows.find((row: any) => row?.visibility === 'Not Visible Individually')
  return getStatusFormatted(variantRow, { sourceShopID, targetShopID }).label
}

export function prepareProductAttributes(productAttribute: any) {
  let tempAttribute: any = [];
  if (productAttribute?.length > 0) {
    productAttribute?.map((event: any) => {
      tempAttribute.push({
        label: event['title'],
        value: event['code']
      })
    })
  }
  return tempAttribute;
}

export function duplicateSKUValidator(marketplace: any, source_product_id: any) {
  let temp: any = {};
  let parentContainer: any = {};
  marketplace?.map((event: any) => {
    if (event?.hasOwnProperty('direct') && event?.direct) {
      parentContainer = {
        ...parentContainer,
        [event?.source_product_id]: event
      }
    }
  })
  temp = { ...parentContainer };
  marketplace?.map((innerLoop: any) => {
    if (innerLoop?.hasOwnProperty('sku') && !innerLoop?.hasOwnProperty('direct')) {
      temp = {
        ...temp,
        [innerLoop.source_product_id]: innerLoop
      }
    }
  })
  let isDuplicateSKUExists: any = false;
  let duplicateSKU = '';
  Object.values(temp)?.map((last: any) => {
    Object.values(temp)?.map((fix: any) => {
      if (last?.sku === fix?.sku && last.source_product_id != fix.source_product_id && !isDuplicateSKUExists) {
        isDuplicateSKUExists = true;
        duplicateSKU = fix?.sku
      }
    })
  })
  return { duplicateSKU, isDuplicateSKUExists };
}

export function switchListingMatchContextualCase(selectionType: any, initialSelectionType: any) {
  let flag: boolean = true;
  Object.keys(selectionType)?.length > 0 && Object.keys(selectionType)?.map((event: any) => {
    if (flag) {
      if (initialSelectionType?.hasOwnProperty(event) && initialSelectionType[event] == selectionType[event]) {
        flag = true;
      } else {
        flag = false;
      }
    }
  })
  return flag;
}

export function isSectionVisible(sectionName: string, componentState: any, modified_product: any) {
  let statusArr = ['Active', 'Inactive', 'Uploaded', 'Incomplete'];
  if (sectionName === 'sku') {
    let status: boolean = false
    if (componentState?.initialProductData?.hasVariants && modified_product?.hasOwnProperty('isParentStatusInComplete') && modified_product?.isParentStatusInComplete === 'parent_incomplete') {
      status = true;
    } else {
      status = (componentState?.product_type.variantEdit || !componentState.initialProductData['hasVariants']) && statusArr.includes(componentState.initialProductData['status'])
    }
    return status
  } else if (sectionName === 'barcode') {
    // return (componentState?.product_type.variantEdit || !componentState.initialProductData['hasVariants']) && statusArr.includes(componentState.initialProductData['status'])
    let status: boolean = false
    if (componentState?.initialProductData?.hasVariants && modified_product?.hasOwnProperty('isParentStatusInComplete') && modified_product?.isParentStatusInComplete === 'parent_incomplete') {
      status = true;
    } else {
      status = (componentState?.product_type.variantEdit || !componentState.initialProductData['hasVariants']) && statusArr.includes(componentState.initialProductData['status'])
    }
    return status
  } else if (sectionName === 'category_settings') {
    let status: boolean = false
    if (componentState?.initialProductData?.hasVariants && modified_product?.hasOwnProperty('isParentStatusInComplete') && modified_product?.isParentStatusInComplete === 'parent_incomplete') {
      status = true;
    } else {
      status = (componentState?.product_type.variantEdit || !componentState.initialProductData['hasVariants']) && statusArr.includes(componentState.initialProductData['status'])
    }
    return status
  } else {
    return false;
  }
}

export function getLocalsellingWarehouseData(activeStoreDetails: any, savedStoreDetails: any, comonentState: any) {
  let storeDetails: any = [];
  activeStoreDetails?.length > 0 && activeStoreDetails?.map((activeStore: any) => {
    if (activeStore?.status != 'Inactive') {
      let singleStoreData: storeSchema = {
        store_enabled: false,
        store_name: activeStore?.store_name,
        store_id: activeStore?.supplySourceId,
        // store_value: '',
        status: activeStore?.status,
        // shopify_location_id: activeStore?.value ?? "",
        // shopify_location_name: activeStore?.label ?? "",
        shopify_location: {}
      };
      storeDetails.push(singleStoreData);
    }
  })
  if (savedStoreDetails?.length > 0) {
    storeDetails?.length > 0 && storeDetails?.map((activeStore: any, index: number) => {
      let storeMatchingStatus: any = isActiveStoreExistsInSavedStore(activeStore?.store_id, savedStoreDetails)
      if (storeMatchingStatus?.success) {
        storeDetails[index] = {
          ...activeStore,
          store_enabled: activeStore?.status === 'Inactive' ? false : savedStoreDetails[storeMatchingStatus?.indexValue]?.store_enabled,
          store_name: savedStoreDetails[storeMatchingStatus?.indexValue]?.store_name,
          store_id: savedStoreDetails[storeMatchingStatus?.indexValue]?.store_id,
          // store_value: savedStoreDetails[storeMatchingStatus?.indexValue]?.store_value,
          // shopify_location_id: savedStoreDetails[storeMatchingStatus?.indexValue]?.shopify_location_id ?? "",
          // shopify_location_name: savedStoreDetails[storeMatchingStatus?.indexValue]?.shopify_location_name ?? "",
          shopify_location: savedStoreDetails[storeMatchingStatus?.indexValue]?.shopify_location ?? {}
        };
      }
    })
  }
  return storeDetails;
}

function isActiveStoreExistsInSavedStore(activeStoreId: any, savedStoreDetails: any) {
  let temp: any = { 'success': false, 'indexValue': false }
  savedStoreDetails?.some((event: any, index: number) => {
    if (activeStoreId === event?.store_id) {
      temp = { 'success': true, 'indexValue': index }
    }
  });
  return temp
}

interface storeSchema {
  store_enabled: boolean;
  store_name: any;
  store_id: any;
  // store_value: any;
  status: any;
  // shopify_location_id: any;
  // shopify_location_name: any;
  shopify_location: any;
}

export const getProductErrors = (state: any, target_id: any, source_id: any, count: any) => {
  let temp: any = { parent: [], variant: [] }
  let tempCount: any = { parent: 0, variant: 0 };
  let type: string = 'parent';
  state?.marketplace?.map((item: any) => {
    if (item?.error && (target_id === item.shop_id)) {
      if (item.source_product_id === state.parent_source_product_id || state?.marketplace?.length === 1) {
        let element = state?.marketplace?.filter((x: any) => x.source_product_id === item.source_product_id && source_id === x.shop_id)[0];
        temp.parent.push({
          "source_product_id": element?.title ?? item.source_product_id, error: item.error,
          toggle: item.source_product_id,
          image: element?.main_image ?? ''
        });
        type = 'parent';
      } else {
        let element = state?.variants?.filter((x: any) => x.source_product_id === item.source_product_id && target_id === x.shop_id)[0];
        temp.variant.push({
          "source_product_id": (element?.title ?? item.source_product_id), error: item.error,
          toggle: item.source_product_id,
          image: element?.main_image ?? ''
        });
        type = 'variant';
      }
      if (item.error && item.error.length) {
        tempCount[type] = tempCount[type] + item.error.length
      } else {
        Object.keys(item.error).map((error: any) => {
          tempCount[type] = tempCount[type] + (item.error[error] ?? item.error[Number(error)]).length;
        })
      }
    }
  })
  return { count: { ...tempCount }, errors: { ...temp } };
}

export function calculateListingScore(data: any, section: string, credit_left: any = false) {
  let result: any;
  if (section == 'title') {
    result = titleScore(data)
  } else if (section == 'description') {
    result = descriptionScore(data, credit_left)
  } else if (section == 'category') {
    result = categoryScore(data)
  } else if (section == "bullet_point") {
    result = bulletPoint(data, credit_left)
  }
  return result
}

function titleScore(data: any) {
  if (data?.length <= 40) {
    return 20;
  } else if (data?.length > 80 && data?.length < 160) {
    return 30;
  } else if (data?.length >= 160) {
    return 60;
  } else return 20
}

function descriptionScore(data: any, credit_left: any) {
  let result: number = 0;
  if (data == '') {
    result = 0;
  } else if (data?.length <= 1000) {
    result = 40;
  } else if (data?.length > 1000 && data?.length <= 2000) {
    result = 50;
  }
  if (data?.includes("<ul ") || data?.includes("<ul>")) {
    result = result + 10
  }
  if (data?.includes("<img")) {
    result = result + 10
  }
  if (credit_left?.description) {
    result = result + 10
  }
  if (result <= 50) {
    return 50;
  } else {
    return result
  }
}

function categoryScore(data: any) {
  if (data?.category) {
    return 1
  } else {
    return 0
  }
}

function bulletPoint(data: any, credit_left: any) {
  let result = 0;
  if (credit_left?.bullet_point) {
    let interval = data?.length <= 4 ? 20 : data?.length <= 5 ? 10 : 10;
    data?.length > 0 && data?.map((item: any) => {
      if (item?.length >= 80) {
        result = result + interval
      }
    })
  }
  return result;
}

export function getVariantBarcodeExemptionValue(state: any) {
  let barcode_exemption: boolean = false;
  if (state?.parent_details && Object.keys(state?.parent_details)?.length > 0) {
    if (state?.parent_details.hasOwnProperty('edited') && state?.parent_details?.edited && state?.parent_details?.edited?.category_settings && state?.parent_details?.edited?.category_settings?.hasOwnProperty('barcode_exemption')) {
      barcode_exemption = state?.parent_details?.edited?.category_settings?.barcode_exemption
    } else if (state?.profile_info && state?.profile_info?.category_settings?.hasOwnProperty('barcode_exemption')) {
      barcode_exemption = state?.profile_info?.category_settings?.barcode_exemption
    }
  }
  return barcode_exemption
}

export function setListingTypeForSourceProductId(responseEditedDoc: [], source_product_ids: any) {
  let getOnlyCategoryEditedDoc = responseEditedDoc.filter((product: any) => product.hasOwnProperty('category_settings') && Object.keys(product?.category_settings)?.length > 0)
  getOnlyCategoryEditedDoc?.map((iterater: any) => {
    if (source_product_ids?.hasOwnProperty(iterater.source_product_id)) {
      let primary_category = iterater?.category_settings?.primary_category && iterater?.category_settings?.primary_category !== '' ? iterater?.category_settings?.primary_category : ''
      source_product_ids = {
        ...source_product_ids,
        [iterater.source_product_id]: {
          ...source_product_ids[iterater.source_product_id],
          listing_type: (source_product_ids[iterater.source_product_id]['product_status'] === 'Not Listed: Offer' || primary_category == 'default') ? "offer_listing" : 'new_listing',
          primary_category: primary_category !== "" ? primary_category : '',
        }
      }
    }
  })
  return source_product_ids
}

export const getProductWarnings = (state: any, target_id: any, source_id: any, count: any) => {
  let temp: any = { parent: [], variant: [] }
  let tempCount: any = { ...count };
  let type: string = 'parent';
  state?.marketplace?.map((item: any) => {
    if (item?.warning && (target_id === item.shop_id)) {
      if (item.source_product_id === state.parent_source_product_id || state?.marketplace?.length === 1) {
        let element = state?.marketplace?.filter((x: any) => x.source_product_id === item.source_product_id && source_id === x.shop_id)[0];
        temp.parent.push({
          "source_product_id": element?.title ?? item.source_product_id, warning: item.warning,
          toggle: item.source_product_id,
          image: element?.main_image ?? ''
        });
        type = 'parent';
      } else {
        let element = state?.variants?.filter((x: any) => x.source_product_id === item.source_product_id && target_id === x.shop_id)[0];
        temp.variant.push({
          "source_product_id": (element?.title ?? item.source_product_id), warning: item.warning,
          toggle: item.source_product_id,
          image: element?.main_image ?? ''
        });
        type = 'variant';
      }
      if (item.warning && item.warning.length) {
        tempCount[type] = tempCount[type] + item.warning.length
      } else {
        Object.keys(item.warning).map((warning: any) => {
          tempCount[type] = tempCount[type] + (item.warning[warning] ?? item.warning[Number(warning)]).length;
        })
      }
    }
  })
  return { count: { ...tempCount }, warnings: { ...temp } };
}